export enum ChallengesTypes {
    Survey = 'C7A0C2B4-9D63-4F6B-BC5A-2B3E8F8E1A72',
    Mixed = '8E4D1A9C-7B6F-4C2E-9A3D-0F5E2B6C1D78',
    SatisfactionSurvey = '3A6F9C2E-1B8D-4E75-9F0A-7C2D6B5E4A91',
    Image = '1F9E6C3A-4B2D-4A8F-9E7A-6C5B3A2D8F41',
    Permanent = 'F3D9C6E2-7B84-4A91-8F5D-2C1E7A9B6D4F'
  }
  